import React from 'react';
import { DropdownToggle } from 'reactstrap';
import cn from 'classnames';
import styles from './index.module.scss';

import { If } from 'utils';
import { UiKit } from 'components';
import DropdownIndicator from '../DropdownIndicator';
import { useDropdown } from '..';

/**
 * @param {Object} props
 * @param {boolean} props.caret
 * @param {import('utils/types').Size} props.size
 * @param {string} props.className
 * @param {React.ElementType} props.component
 * @param {React.ReactNode} props.children
 */
export default function DropdownTrigger({
  size = 'md',
  caret = true,
  className = '',
  component = Toggle,
  children = null
}) {
  const { isOpen, disabled } = useDropdown();

  return (
    <DropdownToggle
      size={size}
      disabled={disabled}
      className={cn(styles.container, className)}
      tag={component}
    >
      <span className={styles.content}>
        {children}
        <If test={caret}>
          <DropdownIndicator
            isOpen={isOpen}
            disabled={disabled}
            hasValue={!!children}
          />
        </If>
      </span>
    </DropdownToggle>
  );
}

function Toggle({ className, ...props }) {
  return <UiKit.Button {...props} variant="outline" className={className} />;
}
